export default __webpack_public_path__ + "static/media/recruiterflow.c6ae2392.jpg";